import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar';
import DateTime from '../DateTime';
import NotificationsText from './Text';

const NotificationsItem = ({ notification }) => {
  const { definition } = notification;

  return (
    <div className="notification-wrapper">
      <div className="notification-avatar">
        <Avatar
          id={`notification-user-${notification.id}`}
          user={notification.user}
          expandable={!!(notification.user && notification.user.uuid)}
        />
        <div className="notification-type">
          <i className={`fal ${definition.icon}`} />
        </div>
      </div>
      <div className="notification-content">
        <div className="notification-header">
          <span className="notification-header-text">
            <NotificationsText notification={notification} />
            <strong>
              <DateTime
                id={`notification-date-${notification.id}`}
                dateTime={notification.created_at}
              />
            </strong>
          </span>
          <div className="notification-header-properties">
            {notification.unread && (
              <div className="notification-unread-badge" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

NotificationsItem.propTypes = {
  notification: PropTypes.object.isRequired,
};

export default NotificationsItem;
